import { ContextApi } from 'contexts/Localization/types'
import { PageMeta } from './types'

export const DEFAULT_META: PageMeta = {
  title: 'STX',
  description:
    'The most popular AMM on BSC by user count! Earn CAKE through yield farming or win it in the Lottery, then stake it in STX Pools to earn more tokens! Initial Farm Offerings (new token launch model pioneered by STX), NFTs, and more, on a platform you can trust.',
  image: 'https://pancakeswap.finance/images/hero.png',
}

export const getCustomMeta = (path: string, t: ContextApi['t']): PageMeta => {
  let basePath
  if (path.startsWith('/swap')) {
    basePath = '/swap'
  } else if (path.startsWith('/add')) {
    basePath = '/add'
  } else if (path.startsWith('/remove')) {
    basePath = '/remove'
  } else if (path.startsWith('/teams')) {
    basePath = '/teams'
  } else if (path.startsWith('/voting/proposal') && path !== '/voting/proposal/create') {
    basePath = '/voting/proposal'
  } else if (path.startsWith('/nfts/collections')) {
    basePath = '/nfts/collections'
  } else if (path.startsWith('/nfts/profile')) {
    basePath = '/nfts/profile'
  } else if (path.startsWith('/pancake-squad')) {
    basePath = '/pancake-squad'
  } else {
    basePath = path
  }

  switch (basePath) {
    case '/':
      return {
        title: `SatoshiX | ${t('Home')}`,
      }
    case '/swap':
      return {
        title: `SatoshiX | ${t('Exchange')}`,
      }
    case '/add':
      return {
        title: `SatoshiX | ${t('Add Liquidity')}`,
      }
    case '/remove':
      return {
        title: `SatoshiX | ${t('Remove Liquidity')}`,
      }
    case '/liquidity':
      return {
        title: `SatoshiX | ${t('Liquidity')}`,
      }
    case '/find':
      return {
        title: `SatoshiX | ${t('Import Pool')}`,
      }
    case '/competition':
      return {
        title: `SatoshiX | ${t('Trading Battle')}`,
      }
    case '/prediction':
      return {
        title: `SatoshiX | ${t('Prediction')}`,
      }
    case '/prediction/leaderboard':
      return {
        title: `SatoshiX | ${t('Leaderboard')}`,
      }
    case '/farms':
      return {
        title: `SatoshiX | ${t('Farms')}`,
      }
    case '/farms/auction':
      return {
        title: `SatoshiX | ${t('Farm Auctions')}`,
      }
    case '/pools':
      return {
        title: `SatoshiX | ${t('Pools')}`,
      }
    case '/lottery':
      return {
        title: `SatoshiX | ${t('Lottery')}`,
      }
    case '/ifo':
      return {
        title: `SatoshiX | ${t('Initial Farm Offering')}`,
      }
    case '/teams':
      return {
        title: `SatoshiX | ${t('Leaderboard')}`,
      }
    case '/voting':
      return {
        title: `SatoshiX | ${t('Voting')}`,
      }
    case '/voting/proposal':
      return {
        title: `SatoshiX | ${t('Proposals')}`,
      }
    case '/voting/proposal/create':
      return {
        title: `SatoshiX | ${t('Make a Proposal')}`,
      }
    case '/info':
      return {
        title: `SatoshiX | ${t('Overview')} | ${t('SatoshiX Info & Analytics')}`,
        description: 'View statistics for Pancakeswap exchanges.',
      }
    case '/info/pools':
      return {
        title: `SatoshiX | ${t('Pools')} | ${t('SatoshiX Info & Analytics')}`,
        description: 'View statistics for Pancakeswap exchanges.',
      }
    case '/info/tokens':
      return {
        title: `SatoshiX | ${t('Tokens')} | ${t('SatoshiX Info & Analytics')}`,
        description: 'View statistics for Pancakeswap exchanges.',
      }
    case '/nfts':
      return {
        title: `SatoshiX | ${t('Overview')}`,
      }
    case '/nfts/collections':
      return {
        title: `${t('Collections')}`,
      }
    case '/nfts/profile':
      return {
        title: `${t('Your Profile')}`,
      }
    case '/pancake-squad':
      return {
        title: `${t('Pancake Squad')}`,
      }
    default:
      return null
  }
}
